var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_758_2743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1174 15.9353L26.9731 14.014L28.3022 9.93448L25.6439 8H7.94422L3.85156 11.0399H24.6571L23.5516 14.4614H15.2084L14.4056 16.9618H22.7489L20.4065 24.1602L24.3148 22.2256L25.7097 17.9093L23.091 15.9879L23.1174 15.9353Z",
    fill: "#FDFD03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73783 21.0677L12.1461 13.5667L9.47465 11.5664L5.46094 24.1602H20.4103L21.4105 21.0677H9.73783Z",
    fill: "#FDFD03"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_758_2743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlast);
export default __webpack_public_path__ + "static/media/blast.68e4baa1dbba303d6d82d1313f996df9.svg";
export { ForwardRef as ReactComponent };